import './animations.js';
import './header.js';
import './slider.js';

jQuery(document).ready(function ($) {
    //var position = $(window).scrollTop();

    $(window).scroll(function () {
        $(".site-header").addClass("on-scroll-down");
        $(".site-header").removeClass("on-scroll-up");
    });

    var adminHeight = $("#wpadminbar").outerHeight();
    var headerHeight = $(".site-header").outerHeight();
    var footerHeight = $(".site-footer").outerHeight();
    var total = headerHeight + footerHeight + 25;

    $(".site-header").css("top", adminHeight);
    $(".content-area").css("padding-top", headerHeight);

    //         if ($(window).width() > 768) {
    //         $(".error-404, .no-results").css( { height: 'calc(100vh - ' + total + 'px)' } );
    //     } 

    // $(window).on("resize", function (e) {
    //     if ($(window).width() > 768) {
    //         $(".error-404, .no-results").css( { height: 'calc(100vh - ' + total + 'px)' } );
    //     } else {
    //         $(".error-404, .no-results").css( { height: '100%' } );
    //     }
    // });



    $(window).on("resize", function (e) {
        var adminHeightResize = $("#wpadminbar").outerHeight();
        var headerHeightResize = $(".site-header").outerHeight();
        $(".site-header").css("top", adminHeightResize);
        $(".content-area").css("padding-top", headerHeightResize + adminHeightResize);
    });

    // Project Tabs
    //$('.project-list-content .tab-content-item').show();
    $(".tab_projects .tab-content-item").hide();
    $(".tab_nav .tab_link").first().addClass("active");
    $(".tab_projects .tab-content-item").first().show();

    $(window).resize(function () {
        if ($(".tab_projects .tab-content-item").hasClass("active")) {
            $(".tab_projects .tab-content-item").hide();
            $(".tab_projects .tab-content-item.active").show();
        } else {
            $(".tab_projects .tab-content-item").hide();
            $(".tab_projects .tab-content-item:first-of-type").show();
        }
    });

    /* if in tab mode */
    $(".tab_nav > .tab_link").click(function () {
        $(".tab_container").hide();
        var activeTab = $(this).attr("rel");

        $(".tab_projects")
            .find("#" + activeTab)
            .fadeIn();
        $(".tab_projects")
            .find("#" + activeTab)
            .addClass("active");
        $(".tab_projects")
            .find("#" + activeTab)
            .siblings()
            .removeClass("active");

        $(this).siblings().removeClass("active");
        $(this).addClass("active");

        var pageCount = $(".tab_projects").find("#" + activeTab).find(".project-list").attr("page_count");
        console.log(pageCount);
        if (pageCount == 1) {
            $(".load-more").hide();
        } else {
            $(".load-more").show();
        }

        $(".tab_select").val(activeTab);
    });

    $(".tab_select").change(function () {
        $(".tab_nav > .tab_link[rel='" + $(this).val() + "']").trigger("click");
    });

    $(".tab_title").click(function () {
        var d_activeTab = $(this).attr("rel");

        if ($(this).hasClass("d_active")) {
            $(this)
                .parent()
                .find("#" + d_activeTab)
                .slideUp();
            $(this).removeClass("d_active");
        } else {
            $(this).addClass("d_active");
            $(this)
                .parent()
                .find("#" + d_activeTab)
                .slideDown();
        }
    });

    if ($(window).width() > 1024) {
        $(".sf-field-search input").click(function () {
            if (!$(this).parent().parent().hasClass("expand")) {
                $(this).parent().parent().addClass("expand");
                $(this)
                    .parent()
                    .parent()
                    .append(
                        '<div class="close-search" alt="close search"><i class="fa-regular fa-xmark"></i></div>'
                    );
            }
        });
        $(".sf-field-search").click(function () {
            if (!$(this).hasClass("expand")) {
                $(this).addClass("expand");
                $(this)
                    .append(
                        '<div class="close-search" alt="close search"><i class="fa-regular fa-xmark"></i></div>'
                    );
            }
        });
    }

    $(document).on("click", ".close-search", function () {
        if ($(this).parent().find(".sf-input-text").val() != "") {
            $(this).parent().find(".sf-input-text").val("");
            $(this).parent().parent().parent(".searchandfilter").submit();
        }

        $(this).parent().removeClass("expand");

        $(this).remove();
    });

   
    $(document).on("click", ".positions .career", function (event) {
        if ($(window).width() > 1024) {
          event.preventDefault();
            if (!$(this).hasClass("active")) {
                var clickedCareer = $(this);
                var details = clickedCareer.find(".career-details");
                $(".positions .career").not(clickedCareer).removeClass("active");
            
                clickedCareer.toggleClass("active");
                details.toggleClass("open");
                $(".positions .career").not(clickedCareer).find(".career-details").removeClass("open");
                //scroll to top of div
                $("html, body").animate(
                    {
                        scrollTop: details.offset().top - 100,
                    },
                    300
                );
            } else if ($(event.target).hasClass("close-panel-icon") || $(event.target).hasClass("career-card")) {
                $(".positions .career").removeClass("active");
                $(".positions .career-details").removeClass("open");
            }
        }
    });
      
    $(".positions .career-details").removeClass("hidden");

    //Doesn't allow the panel to cover pagination
    if ($('.pagination').length) {
        var paginationHeight = $('.pagination').outerHeight(true) + 20;
        $('.career-details').height('calc(100% - ' + paginationHeight + 'px)');
    }

    $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
        equalizeCardHeights();
        if ($('.pagination').length) {
            var paginationHeightAjax = $('.pagination').outerHeight(true) + 20;
            $('.career-details').height('calc(100% - ' + paginationHeightAjax + 'px)');
        }
    });

    $(".positions .career:nth-of-type(even)").addClass('even');

    //Equalize card heights
    function equalizeCardHeights() {
        const cards = document.querySelectorAll(
            ".positions .career .career-card"
        );

        let maxCardHeight = 0;
        cards.forEach((card) => {
            card.style.height = "auto";
            const cardHeight = card.offsetHeight;
            if (cardHeight > maxCardHeight) {
                maxCardHeight = cardHeight;
            }
        });

        cards.forEach((card) => {
            card.style.height = maxCardHeight + "px";
        });
    }

    if ($(window).width() > 768) {
        // Call the function on window load and resize
        window.addEventListener("load", equalizeCardHeights);
        window.addEventListener("resize", equalizeCardHeights);
    }
    
    if ($('.testimonial-badge').length === 0) {
        $('.testimonial-content').addClass('no-badges');
    }
   

    // Load the YouTube API
    // Get the wrapping div element
    const videoWrapper = document.querySelector(".video-callout");

    // Check if the wrapping div element is present
    if (videoWrapper) {
        // If the wrapping div element is present, attach the event listener to the video overlay element
        const videoOverlay = document.getElementById("video-overlay");
        videoOverlay.addEventListener("click", function () {
            const iframe = document.querySelector(".video iframe");
            videoOverlay.style.display = "none";
            iframe.src += "?autoplay=1";
        });
    }

   

    $('.open-modal').click(function(){
        $(this).find('a').removeAttr('href');
        $('#myModal').fadeIn();
        $('.modal-overlay').fadeIn();
    });

    $('#myModal button').click(function(){
        $('#myModal').fadeOut();
        $('.modal-overlay').fadeOut();
    });

    
    
});
